// import node_modules
import * as PropTypes from 'prop-types';
import * as React from 'react';

// import types
import type { GetStaticProps, NextPage } from 'next';
import { RouteEnum } from '../../types';

// import component
import FeaturesTemplate from '../../components/templates/FeaturesTemplate';

// define page
const FeaturesPage: NextPage<{ hrefLang: string }> = ({ hrefLang }) => (
  <FeaturesTemplate hrefLang={hrefLang} />
);

FeaturesPage.propTypes = {
  hrefLang: PropTypes.string.isRequired,
};

export const getStaticProps: GetStaticProps = async () => {
  // init vars
  const hrefLang = RouteEnum.WEBSITE_FEATURES_EN;

  return { props: { hrefLang } };
};

export default FeaturesPage;
